export default __webpack_public_path__ + "static/media/Monk's Robes of Balance.1f9ae49c.jpg";